import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Footer } from "../components/Footer";
import Typography from '@mui/material/Typography'
import { GlobalStyles, Paper } from "@mui/material";
import { useContext, useEffect } from "react";
import { AppContext } from "../context";
import React from "react";
import { useLocation } from "react-router-dom";
import { CardUser } from "../components/CardUser";

import { useWindowDimensions } from "../hooks/useWindowDimensions";



function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const UserCardPage = () => {
  const {  logo, getThemeAndPlans, getLead, lead } =  useContext<any>(AppContext);
  let query = useQuery();
  const id = query.get('id');
  const product = query.get('product');
  const printRef = React.useRef();

  const { width } = useWindowDimensions();


  useEffect(() => {
    getThemeAndPlans(product)
    getLead(id)
    console.log(id)
  }, [])

    return (
      <>

      {lead.name && (
        <Container component="main" maxWidth="md">
        <GlobalStyles
        styles={{
          body: { 
          backgroundColor: `white`}
        }}
        />
          <Paper 
          variant="outlined" 
          elevation={2}
          sx={{
            my: 8,
            backgroundColor: `white`,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            justifyContent: 'space-evenly',
            maxHeight: 700,
            border: 0
           }}
          >
            <img src={logo} alt=""  style={{margin: '0 auto', width: '250px'}}/>
            <Typography
             sx={{color: 'primary.main', fontSize: '2.4rem', mx: 5, fontWeight: 'bold'}}
             align='center'>
              Aqui está sua carteirinha!
            </Typography>
            <Box ref={printRef} sx={{ml: width> 400 ? 7 : 0, maxWidth: 750}}>
              {lead.name && (
            <CardUser />
              )}
            </Box>
            <Box sx={{width:'100wv',
                    alignItems: "center"}}>
          <Footer />
          </Box>
          </Paper>
         
        </Container>
      )}

      </>
    )
}